import React from "react"
import PropTypes from "prop-types"
import { Form, Input, DatePicker, Button, Flex, Row, Col } from "antd"
import IconWithBg from "ui/IconWithBg"
import { Delete } from "ui/Icon/DSIcon/Delete"
import styles from "../index.module.css"
import LabeledField from "pagesV2/client/Profile/Tabs/ProfileInfo/LabeledField"

export const MinorGuestForm = ({ t, form, setIsFormValid }) => {
  // Real-time validation for guardian form
  const handleFieldsChange = () => {
    if (form && typeof setIsFormValid === "function") {
      const values = form.getFieldsValue()
      const minors = values.minors || []
      const valid = minors.length > 0 && minors.every((minor) => minor.fullName?.trim() && minor.dateOfBirth)
      setIsFormValid(valid)
    }
  }
  return (
    <Form form={form} layout="vertical" initialValues={{ minors: [{}] }} onFieldsChange={handleFieldsChange}>
      <Form.List name="minors">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => (
              <React.Fragment key={key}>
                <Flex gap={10} align="center" justify="space-between" className={styles.minorHeader}>
                  <div className={`${styles.subTitle} mb-l`}>Minor Guest {name + 1}</div>
                  {fields.length > 1 && (
                    <Flex align="end" className="h-full" onClick={() => remove(name)}>
                      <IconWithBg className={styles.deleteIcon} height={18} width={18} icon={<Delete fill="#ff0000" />} />
                    </Flex>
                  )}
                </Flex>
                <Row gutter={[16, 16]} className={styles.formRow}>
                  <Col xl={12} span={24} className={styles.formCol}>
                    <LabeledField labelKey="Full Name*" name={[name, "fullName"]} rules={[{ required: true, message: "Enter minor name" }]}>
                      <Input placeholder="Enter minor name" />
                    </LabeledField>
                  </Col>
                  <Col xl={12} span={24} className={styles.formCol}>
                    <LabeledField
                      labelKey="Date of Birth*"
                      name={[name, "dateOfBirth"]}
                      rules={[{ required: true, message: "Enter date of birth" }]}
                    >
                      <DatePicker className="w-full p-xs" style={{ width: "100%" }} placeholder="Enter date of birth" format="MM/DD/YY" />
                    </LabeledField>
                  </Col>
                </Row>
              </React.Fragment>
            ))}
            <Button color="primary" variant="outlined" className="mb-m" onClick={() => add()}>
              Add Minor guest
            </Button>
          </>
        )}
      </Form.List>
    </Form>
  )
}

MinorGuestForm.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.shape({
    getFieldsValue: PropTypes.func.isRequired
  }).isRequired,
  setIsFormValid: PropTypes.func.isRequired
}
